<template>
  <PartnerForm/>
</template>

<script>

import PartnerForm from "@/views/partners/PartnerForm.vue";
export default {
  components: {PartnerForm}

}
</script>


<style scoped lang="scss">

</style>